import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Moment from 'react-moment';

class EditOfftakeEntryRightPan extends Component {

  // constructor(props) {
  //   super(props);
  // }

  render() {
    const { offtakeEntry } = this.props;
    return (
      <div>
        <Row>
          <Col className="title-right-pan">
            Invoice Details
          </Col>
        </Row>

        <Row style={{ marginLeft: '-20px', marginRight: '-20px' }}>
          <Col style={{ padding: '0' }}>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col xl="3" md="3" sm="6" xs="6">
            <span className="offtake-edit-mode-label text-overflow-dots">Invoice Number</span> <br />
            <label className="offtake-edit-mode-value text-overflow-dots">{offtakeEntry.invoice_number}</label>
          </Col>

          <Col xl="3" md="3" sm="6" xs="6">
            <span className="offtake-edit-mode-label text-overflow-dots">Purchase Date</span> <br />
            <label className="offtake-edit-mode-value text-overflow-dots">
              <Moment format="DD MMM YYYY">
                {offtakeEntry.purchase_date}
              </Moment>
            </label>
          </Col>
          <Col>
            <span className="offtake-edit-mode-label text-overflow-dots">Submission Date</span> <br />
            <label className="offtake-edit-mode-value text-overflow-dots">
              <Moment format="DD MMM YYYY">
                {offtakeEntry.created_at}
              </Moment>
            </label>
          </Col>
        </Row>

        <Row>
          <Col xl="3" md="3" sm="6" xs="6">
            <span className="offtake-edit-mode-label text-overflow-dots">Dealer Name</span> <br />
            <label className="invoice-value-right">{offtakeEntry.dealer_name}</label>
          </Col>
          <Col>
            <span className="offtake-edit-mode-label text-overflow-dots">Fleet Name</span> <br />
            <label className="invoice-value-right">{offtakeEntry.fleet}</label>
          </Col>
        </Row>

        <Row>
          <Col>
            <span className="offtake-edit-mode-label text-overflow-dots">Invoice in favour of</span> <br />
            <label className="offtake-edit-mode-value text-overflow-dots">{offtakeEntry.subsidiary_name}</label>
          </Col>
        </Row>

        <Row style={{ marginTop: '20px' }}>
          <Col>

            <table className="table table-bordered table-responsive">
              <thead id="wc-table-head" className="offtake-check-table-head">
                <tr>
                  <th>Product Description</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody id="wc-table-body">
                {
                  (offtakeEntry.product || []).map((item) => {
                    return (
                      <tr key={item.invoice_number}>
                        <td>
                          {item.description.name}
                        </td>
                        <td>
                          {item.quantity}
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default EditOfftakeEntryRightPan;